<template>
    <main id="app" class="h-screen w-screen">
        <navbar-app />

        <div id="app-container" class="container mx-auto pt-5">
            <div class="w-full h-20"></div>
            <sidebar-app />
            <router-view />
            <div class="w-full h-20"></div>
        </div>
        <footer-app />
        <support-whatsapp-button v-if="$isMultitenant" />
        <plan-upgrade-host />
        <legal-acceptance-modal />
    </main>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

import FooterApp from "@/components/layout/FooterApp.vue";
import NavbarApp from "@/components/layout/NavbarApp.vue";
import PlanUpgradeHost from "@/components/layout/PlanUpgradeHost.vue";
import SidebarApp from "@/components/layout/SidebarApp.vue";
import SupportWhatsappButton from "@/components/layout/SupportWhatsappButton.vue";
import LegalAcceptanceModal from "@/components/legal/LegalAcceptanceModal.vue";

export default {
    name: "LayoutApp",
    components: {
        FooterApp,
        LegalAcceptanceModal,
        SidebarApp,
        NavbarApp,
        PlanUpgradeHost,
        SupportWhatsappButton
    },
    computed: {
        ...mapState("auth", [
            "accessToken",
            "needOnboardingTenant",
            "sessionCoreLoaded"
        ]),
        ...mapState("control", ["tenantStackColors"]),
        ...mapGetters("onboarding", ["routeForStep"])
    },
    created() {
        this.$watch(
            () => this.$route,
            () => {
                document
                    .getElementById("app-container")
                    .scrollIntoView({ behavior: "smooth" });
            },
            {
                deep: true
            }
        );
    },
    async mounted() {
        // Las variables CSS no sobreviven a una recarga: se re-aplica lo
        // guardado, sin pedir branding.
        this.SET_TENANT_STACK_COLORS(this.tenantStackColors);
        this.completeSessionIfNeeded();

        if (!this.needOnboardingTenant) return;
        try {
            const data = await this.getOnboardingStatus();
            const flow = data.onboardingFlow;
            if (!flow || flow.status === "completed") return;

            // Sin diálogo ni opción de posponer: el onboarding incompleto no
            // es negociable, así que /app redirige de inmediato al step
            // pendiente en vez de dejar al usuario decidir si sigue en /app.
            const route = this.routeForStep(flow.step);
            if (route) {
                this.$router.push(route);
            }
        } catch {
            // Status endpoint not available
        }
    },
    methods: {
        ...mapMutations("control", [
            "APPLY_SIDEBAR_ITEMS",
            "SET_TENANT_STACK_COLORS"
        ]),
        ...mapActions("onboarding", ["getOnboardingStatus"]),
        ...mapActions("auth", ["getProfile"]),
        // Sesiones guardadas antes de que sign-in trajera el núcleo de
        // sesión: se completan una sola vez.
        async completeSessionIfNeeded() {
            if (!this.accessToken || this.sessionCoreLoaded) return;
            try {
                await this.getProfile();
            } catch {
                // Sin núcleo: se reintenta en la siguiente carga
            }
        }
    }
};
</script>
